import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const staffApi = createApi({
    reducerPath: "base/staff",
    baseQuery: axiosBaseQuery,
    tagTypes: ["staffList"],
    endpoints: (builder) => ({
        staffFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['staffList'],
            query: (query = '') => ({
                url: "/base/users" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data, // The array of data
                    pagination: response.pagination, // Pagination info
                };
            },
        }),

        staffCreate: builder.mutation({
            invalidatesTags: ['staffList'],
            query: (data) => ({ url: "/base/users", method: "POST", data })
        }),
        staffUpdate: builder.mutation({
            invalidatesTags: ['staffList'],
            query: (data) => ({ url: "/base/users/" + data.id, method: "PUT", data })
        }),
        staffDelete: builder.mutation({
            invalidatesTags: ['staffList'],
            query: (id) => ({ url: "/base/users/" + id, method: "DELETE" })
        }),
    })
})

export const { useStaffFindAllQuery, useStaffCreateMutation, useStaffUpdateMutation, useStaffDeleteMutation } = staffApi;
export { staffApi };
